<script>
import options from "./FormSalesContactSection.options"
const componentOptions = options
export default componentOptions
</script>

<template>
    <article class="be-form-sales-contact-section be-color-theme--white-blue-highlight">
        <form class="be-form-layout" v-if="!successObject?.success" v-on:submit.prevent>
            <div class="be-form-layout__group">
                <h2 class="be-form-layout__group-header">{{ labels.title }}</h2>
                <div class="be-form-layout__group-items be-form-layout__group-items--2col">
                    <FormInputGeneric
                        inputName="companyName"
                        v-model="companyName"
                        :modelValue="companyName"
                        :label="labels.companyNameLabel"
                        :isRequired="true"
                        :placeholder="labels.companyNamePlaceholder"
                        :isValidationError="displayErrors && !nameValidator(companyName)"
                        :isValid="displayErrors"
                        :helpMessageLabel="labels.companyNameHelpText"
                        :errorMessageLabel="labels.companyNameErrorLabel" />
                    <FormInputGeneric
                        inputName="jobTitle"
                        v-model="jobTitle"
                        :modelValue="jobTitle"
                        :label="labels.jobTitleLabel"
                        :placeholder="labels.jobTitlePlaceholder"
                        :helpMessageLabel="labels.jobTitleHelpText"
                        :errorMessageLabel="labels.jobTitleErrorLabel" />
                    <FormInputGeneric
                        inputName="firstName"
                        v-model="firstName"
                        :modelValue="firstName"
                        :label="labels.firstNameLabel"
                        :isRequired="true"
                        :placeholder="labels.firstNamePlaceholder"
                        :isValidationError="displayErrors && !nameValidator(firstName)"
                        :helpMessageLabel="labels.firstNameHelpText"
                        :isValid="displayErrors && nameValidator(firstName)"
                        :errorMessageLabel="labels.firstNameErrorLabel" />
                    <FormInputGeneric
                        inputName="lastName"
                        v-model="lastName"
                        :modelValue="lastName"
                        :label="labels.lastNameLabel"
                        :isRequired="true"
                        :placeholder="labels.lastNamePlaceholder"
                        :helpMessageLabel="labels.lastNameHelpText"
                        :isValidationError="displayErrors && !nameValidator(lastName)"
                        :isValid="displayErrors && nameValidator(lastName)"
                        :errorMessageLabel="labels.lastNameErrorLabel" />
                    <FormInputGeneric
                        inputName="email"
                        v-model="email"
                        :modelValue="email"
                        :label="labels.emailLabel"
                        :isRequired="true"
                        :placeholder="labels.emailPlaceholder"
                        :helpMessageLabel="labels.emailHelpText"
                        :isValidationError="displayErrors && !emailValidator(email)"
                        :isValid="displayErrors && emailValidator(email)"
                        :errorMessageLabel="labels.emailErrorLabel" />
                    <FormInputGeneric
                        inputName="phone"
                        v-model="phone"
                        :modelValue="phone"
                        :label="labels.phoneLabel"
                        :placeholder="labels.phonePlaceholder"
                        :isValidationError="displayErrors && !phoneValidator(phone) && phone !== ''"
                        :isValid="displayErrors && phoneValidator(phone) || displayErrors && phone === ''"
                        :onlyShowValidateOnError="phone === ''"
                        :helpMessageLabel="labels.phoneHelpText"
                        :errorMessageLabel="labels.phoneErrorLabel" />
                </div>
            </div>

            <div class="be-form-layout__group">
                <h2 class="be-form-layout__group-header">{{ labels.messageTitle }}</h2>
                <FormInputTextarea
                    inputName="message"
                    v-model="message"
                    :modelValue="message"
                    :isRequired="true"
                    :label="labels.messageLabel"
                    :placeholder="labels.messagePlaceholder"
                    :isValidationError="displayErrors && !nonEmptyStringValidator(message)"
                    :isValid="displayErrors && nonEmptyStringValidator(message)"
                    :helpMessageLabel="labels.messageHelpText"
                    :errorMessageLabel="labels.messageErrorLabel" />
            </div>

            <div class="be-form-layout__group">
                <FormInputCheckbox
                    inputName="consent"
                    :modelValue="consent.toString()"
                    :isRequired="true"
                    :label="labels.consentLabel"
                    :isValidationError="displayErrors && !consent"
                    :onChangeCallback="(e) => (consent = e.target.checked)"
                    :errorMessageLabel="labels.consentErrorLabel" />
            </div>

            <div class="be-form-layout__actions">
                <button v-on:click="submitForm" class="be-btn">{{ labels.submitButtonLabel }}</button>
            </div>
        </form>

        <div class="be-form-layout-success be-color-theme--white-black" v-if="successObject?.success">
            <h2 class="be-form-layout-success__title">{{ labels.submitSuccessTitle }}</h2>
            <p class="be-form-layout-success__description">{{ labels.submitSuccessMessage }}</p>
            <div class="be-form-layout-success__actions">
                <a class="be-btn" :href="labels.submitSuccessLinkUrl">{{ labels.submitSuccessLinkText }}</a>
            </div>
        </div>

    </article>
</template>
